import {publish} from '@/script/event.mjs'

export const usePluginSaveMap = () => {
    const extensions = () => {
        return {
            canSaveMap() {
                if (! this.permission.has('write')) {
                    this.logger.error('没有保存权限')
                    return false
                }

                const bn = this.BizNode[this.componentType ?? this.productType]

                if ('function' !== typeof bn.updateMap) {
                    this.logger.error('不支持保存')
                    return false
                }

                return true
            },

            async cmdSaveMap() {
                await this.runAction(
                    () => this.execute(
                        async () => {
                            await this.saveMap()
                            publish(this, 'save')
                        }
                    ),

                    {action: '保存地图'},
                )
            },

            async saveMap() {
                const bn = this.BizNode[this.componentType ?? this.productType]
                await bn.updateMap(this, this.root)
            },

            useCanSaveMap() {
                this.usePermission()
                return this.canSaveMap()
            },
        }
    }

    return {extensions}
}
